import React, {useState} from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import Spinner from '../../utils/Spinner';
import msLogo from '../../img/MIND_MS_LOGO.svg';

  const InfoConfirmation = ({tokenInfo}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {
    setIsLoading(true);
    axios.post(`/subscription/v1/get-customer-billing-portal/${tokenInfo.activationToken	}`).then((response) => {
      window.location.href = response.data.paymentUrl	;
      console.log(response)
    })
    .catch((error) => {
      toast('ERROR GETTING THE CUSTOMER PORTAL', {
        autoClose: 6000,
        type: toast.TYPE.ERROR,
      });
    })
    .finally(() => {
      setIsLoading(false);
    });
  }
  return (
    <>
      <div className="relative transform overflow-hidden rounded-[15px] bg-254C5A text-left shadow-xl transition-all w-full max-w-lg mx-auto p-9">
        <div className="grid grid-cols-1 gap-4 justify-items-center">
          <div className="sm:col-span-1 flex justify-center">
            <img src={msLogo} style={{height: '120px'}}></img>  
          </div>

          <div className="grid grid-cols-1 gap-4 justify-items-center mb-3">
            
            {tokenInfo.tokenUsed &&
              <div className="sm:col-span-1">
                <h2 className="text-white font-bold text-xl">Token is already used</h2>
                <span className='text-white'>Please request a new subscription</span>
              </div>
            }

            {!tokenInfo.tokenUsed &&
              <>
                {!tokenInfo.isOnError && 
                <>
                  <div className="sm:col-span-1">
                    <h2 className="text-white font-bold text-2xl">Welcome Back!</h2>
                  </div>

                  <div className="sm:col-span-1 text-center">
                    <span className="text-white">Company Name</span>
                    <h2 className="text-B3DFD8 font-bold text-2xl">{tokenInfo.clientName}</h2>
                  </div>

                  <div className="sm:col-span-1 text-center">
                    <span className="text-white">First Name</span>
                    <h2 className="text-B3DFD8 font-bold text-2xl">{tokenInfo.customerFirstName}</h2>
                  </div>

                  <div className="sm:col-span-1 text-center">
                    <span className="text-white">Last Name</span>
                    <h2 className="text-B3DFD8 font-bold text-2xl">{tokenInfo.customerLastName}</h2>
                  </div>

                  <div className="sm:col-span-1 text-center">
                    <span className="text-white">Email</span>
                    <h2 className="text-B3DFD8 font-bold text-2xl">{tokenInfo.email}</h2>
                  </div>

                  {tokenInfo.creationStarted && 
                    <div className="sm:col-span-1 text-center">
                      <span className="text-white text-xl font-bold">Your instance creation has started, check your email for your credentials</span>
                      <h2 className="text-B3DFD8 font-bold text-2xl">{tokenInfo.creationStarted}</h2>
                    </div>
                  }

                  {!tokenInfo.creationStarted && !tokenInfo.hasCustomerPaymentMethod && 
                    <div className="sm:col-span-1 text-center">
                      <button onClick={handleSubmit} className="bg-8A8988 text-white font-bold text-base rounded-[12px] h-10 w-fit px-2 hover:bg-ETWOrange disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-500 disabled:shadow-none dark:disabled:border-gray-700 dark:disabled:bg-gray-800/20 " disabled={isLoading}>
                        {isLoading ? <Spinner /> : 'Continue to Payment'}
                      </button>
                    </div>
                  }
                </>
                }
                 {tokenInfo.isOnError &&
                   <div className="sm:col-span-1 text-center">
                      <span className="text-white">Cannot create a new subscription</span>
                      <h2 className="text-red-500 font-bold text-2xl">{tokenInfo.errorMessage}</h2>
                    </div>
                 }
                
              </>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default InfoConfirmation;